// extracted by mini-css-extract-plugin
export default {"title":"TransferInfo_title__YznOL","info":"TransferInfo_info__8JylV","p":"TransferInfo_p__Tq+Oe","pair":"TransferInfo_pair__oDxBD","label":"TransferInfo_label__qQz-D"};